/* =====================================================================
 * TSG Header — drawer toggle + cart drawer bridge
 * ===================================================================== */

(function () {
  'use strict';

  function initHeader(header) {
    const drawer       = header.querySelector('[data-tsg-drawer]');
    const openButtons  = header.querySelectorAll('[data-tsg-drawer-open]');
    const closeButtons = header.querySelectorAll('[data-tsg-drawer-close]');
    const cartTrigger  = header.querySelector('[data-tsg-cart-trigger]');
    const cartCountEl  = header.querySelector('[data-tsg-cart-count]');

    // ─── Drawer toggle ──────────────────────────────────────────

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      openButtons.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      // Move focus into drawer for a11y
      const firstLink = drawer.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.hidden = true;
      document.body.style.overflow = '';
      openButtons.forEach((b) => b.setAttribute('aria-expanded', 'false'));
    }

    openButtons.forEach((btn) => btn.addEventListener('click', openDrawer));
    closeButtons.forEach((btn) => btn.addEventListener('click', closeDrawer));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
    });

    // ─── Cart drawer bridge ──────────────────────────────────────
    // If a Dawn <cart-drawer> custom element exists on the page, open it
    // instead of navigating to /cart. Otherwise let the link navigate.

    if (cartTrigger) {
      cartTrigger.addEventListener('click', (e) => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          e.preventDefault();
          cartDrawer.open(cartTrigger);
        }
      });
    }

    // ─── Cart count sync ─────────────────────────────────────────
    // Dawn dispatches PUB_SUB_EVENTS.cartUpdate when cart changes.
    // Re-fetch /cart.js to keep the badge accurate.

    async function syncCartCount() {
      if (!cartCountEl) return;
      try {
        const res = await fetch(window.routes?.cart_url + '.js' || '/cart.js');
        if (!res.ok) return;
        const cart = await res.json();
        cartCountEl.textContent = '(' + (cart.item_count || 0) + ')';
      } catch (err) {
        /* silent */
      }
    }

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, syncCartCount);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-tsg-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const header = e.target.querySelector('[data-tsg-header]');
    if (header) initHeader(header);
  });
})();
